import { LOAD_REQUEST } from "../constants/constants";
import { finishLoad } from "../actions/request";

export default ({dispatch}) => next => action =>{
    switch(action.type){
        case LOAD_REQUEST:
            setTimeout(finishLoad, 10000);
    }
    next(action);
}


// WEBPACK FOOTER //
// ./src/middlewares/requestQuee.js